<template>
  <div class="hyp-container">
    <v-container fluid bg fill-height grid-list-md text-center>
      <v-row row wrap align="center">
        <v-col class="display-1 col-12">
          <img :src="logoSrc" width="200px" class="logo" />
          <br /><br />
          <slot></slot>
        </v-col>
        <v-col v-if="showSigninLink" class="headline col-12">
          Go to <a href="/">Seerist Signin</a>
        </v-col>
        <v-col v-if="showSignoutLink" class="headline col-12">
          Go to <a href="/logout">Seerist Signin</a>
        </v-col>
        <v-col class="headline col-12 mt-16">
          If you need any help please contact<br />
          Seerist Support by email
          <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { SUPPORT_EMAIL } from "@/common/constants/misc";

export default {
  name: "Info",
  props: {
    showSigninLink: {
      type: Boolean,
      default: false,
    },
    showSignoutLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoSrc() {
      return require("@/assets/images/seerist_logo_large.png");
    },
  },
  created() {
    this.SUPPORT_EMAIL = SUPPORT_EMAIL;
  },
};
</script>

<style scoped>
.bg {
  background: #191a1a;
  color: #fff;
}
</style>
